<template>
  <div class="class-container">
    <van-pull-refresh v-model="isLoading"
                      @refresh="onRefresh"
                      ref="refPullRefresh">
      <van-list v-model="info.loading"
                :finished="info.finished"
                :offset="20"
                @load="loadMore">
        <div class="class-list">
          <div class="class-item"
               v-for="(item,index) in dataList"
               :key="index">
            <div class="item-header">
              {{item.class_name}}
            </div>
            <div class="item-footer">
              <div class="footer-left">班级码{{item.class_no}}</div>
              <div class="footer-right"
                   @click="goClassDetails(item)">
                <div class="class-people-num">{{item.student_count}}人已加入班级
                </div>
                <van-icon :name='require("@/assets/images/icon-right-1.png") '
                          size="10" />
              </div>
            </div>
          </div>
        </div>
        <NoData text="暂未创建班级"
                :placeholderImage="require('@/assets/images/bg-noData-1.png')"
                v-if="!dataList.length && !info.loading">
          <div class="confirm"
               @click="createClass">
            创建班级
          </div>
        </NoData>
      </van-list>
    </van-pull-refresh>
    <div class="create-btn"
         @touchsatrt="btntouchSatrt"
         @touchmove="btnMouseMove"
         @click="createClass"
         v-if="dataList.length"><span>创建</span><span>班级</span></div>
    <van-popup class="create-class-popup"
               :close-on-click-overlay="false"
               v-model="show">
      <div class="create-class-title">
        创建班级
      </div>
      <div class="create-class-content">
        <div class="tips">班级创建成功后自动生成班级码</div>
        <van-field v-model="className"
                   maxlength="50"
                   placeholder="请输入班级名称" />
      </div>
      <div class="create-class-footer">
        <div class="cancel"
             @click="cancel">
          取消
        </div>
        <div class="confirm"
             @click="confirm">
          确认
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import NoData from '@/components/NoData/NoData'
import { HttpFactory } from '@/assets/js/common'
import rqParams from './rq'
export default {
  name: 'ClassData',
  components: {
    NoData
  },
  data() {
    return {
      count: 0,
      isLoading: false,
      sL: 0,
      sT: 0,
      dataList: [],
      show: false,
      className: '',
      info: {
        loading: false,
        finished: false,
        page_no: 0,
        page_size: 20,
        total_count: 0
      }
    }
  },
  created() {
  },
  mounted() {
    this.bindEvent()
  },
  methods: {
    onRefresh() {
      this.info.finished = false
      this.info.loading = true
      this.loadMore()
    },
    loadMore() {
      if (this.isLoading) {
        this.dataList = []
        this.isLoading = false
      }
      HttpFactory.postUrl(rqParams.getClassInfoList({
        page_no: this.info.page_no,
        page_size: this.info.page_size
      }), res => {
        const data = res.data || []
        this.info.total_count = res.paginator.total_count || 0
        if (this.info.page_no === 0) {
          this.dataList = data
        } else {
          this.dataList = this.dataList.concat(data)
        }
        this.info.loading = false
        if (this.info.total_count > this.info.page_size * (this.info.page_no + 1)) {
          this.info.page_no = this.info.page_no + 1
        } else {
          this.info.finished = true
        }
      }, () => {
        this.info.loading = false
        this.info.finished = true
      })
    },
    /**
     * @description 班级详情
     */
    goClassDetails(row) {
      location.href = `./ClassDetails.html?class_id=${row.id}`
    },
    /**
     * @description 创建班级
     */
    createClass() {
      this.show = true
      this.className = ''
    },
    btntouchSatrt(e) {
      e.preventDefault()
      const touch = e.targetTouches[0]
      this.sL = touch.pageX - e.target.offsetLeft
      this.sT = touch.pageY - e.target.offsetTop
    },
    btnMouseMove(e) {
      e.preventDefault()
      const touch = e.targetTouches[0]
      let target = e.target
      if (target.nodeName === 'SPAN') {
        target = target.parentElement
      }
      target.style.top = (touch.pageY - this.sT - 30) + 'px'
      target.style.left = (touch.pageX - this.sL - 30) + 'px'
    },
    cancel() {
      this.show = false
    },
    confirm() {
      if (this.className === '') {
        this.$toast('班级名称不能为空')
        return
      }
      HttpFactory.postUrl(rqParams.createClassInfo({
        class_name: this.className
      }), res => {
        this.$toast('班级创建成功')
        this.show = false
        this.info.page_no = 0
        this.loadMore()
      })
    },
    bindEvent() {
      this.classContainerScroll(this.$refs.refPullRefresh)
    },
    /**
     * @description UI要求的
     */
    classContainerScroll({ $el }) {
      $el.onscroll = function(e) {
        if (e.target.scrollTop > 15) {
          e.target.parentElement.classList.add('no-top-padding')
        } else {
          e.target.parentElement.classList.remove('no-top-padding')
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.class-container {
  position: relative;
  padding: 15px 0 10px 15px;
  overflow: hidden;
  height: 100%;
  background: #f7f8f9;
  box-sizing: border-box;
  .van-pull-refresh {
    height: 100%;
    overflow: auto;
    scroll-behavior: smooth;
  }
  /deep/ .van-list {
    height: 100%;
  }
  .class-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 73px;
    border-radius: 8px;
    padding: 14px 16px 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-right: 15px;
    background: #fff;
    .item-header {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
    .item-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .footer-left {
        color: #ccc;
        font-size: 14px;
      }
      .footer-right {
        display: flex;
        align-items: center;
        color: #45d585;
        font-size: 12px;
        .class-people-num {
          margin-right: 5px;
        }
      }
    }
  }
  .create-btn {
    width: 66px;
    height: 66px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    color: #fff;
    font-size: 15px;
    padding: 5px;
    box-sizing: border-box;
    text-align: center;
    position: fixed;
    z-index: 10;
    bottom: 13%;
    right: 10px;
    background-color: #45d585;
    flex-direction: column;
    justify-content: center;
    user-select: none;
  }
  .create-class-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 295px;
    height: 219px;
    background: #ffffff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 20px;
    .create-class-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 14px;
    }
    .create-class-content {
      width: 100%;
      .tips {
        font-size: 14px;
        color: #bbbbbb;
        line-height: 19px;
        margin-bottom: 10px;
      }
      .van-field {
        padding: 0;
        /deep/ .van-field__body {
          height: 100%;
          .van-field__control {
            height: 36px;
            border-radius: 6px;
            border: 1px solid #dfdfdf;
            padding-left: 10px;
          }
        }
      }
      margin-bottom: 16px;
    }
    .create-class-footer {
      display: flex;
      .cancel {
        width: 107px;
        height: 40px;
        background: #f4f4f4;
        border-radius: 24px;
        margin-right: 20px;
        text-align: center;
        line-height: 40px;
        color: #666;
        font-size: 16px;
      }
      .confirm {
        width: 107px;
        height: 40px;
        background: #46d584;
        border-radius: 24px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  /deep/ .noData {
    img {
      width: 70px;
      height: 80px;
    }
    .confirm {
      width: 124px;
      height: 40px;
      background: #46d584;
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 16px;
      margin-top: 24px;
    }
  }
}
.no-top-padding {
  padding-top: 0;
}
</style>
